import styled from 'styled-components';

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  flex-direction: column;
  justify-content: flex-end;
`;

// Texts
export const Text = styled.p`
  font-size: 14px;
`;

export const CenterText = styled(Text)`
  text-align: center;
  margin-bottom: 20px;
  max-width: 49ch;
`;

export const Link = styled.a`
  color: black;
  font-size: 14px;
`;

export const FormTitle = styled.h3`
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

// Inputs
export const ResetPasswordWrapper = styled.div`
  width: fit-content;
  margin: 0 auto;
`;

export const LoginInput = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  align-self: center;
  width: 400px;
`;

export const ModalInput = styled(LoginInput)`
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  width: 100%;
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 11px;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const Input = styled.input`
  max-width: 100%;
  height: 100%;
  width: 100%;
  padding: 0 80px 0 8px;
  font-weight: bold;
  border: 1px solid #c9cbd3;
  border-radius: 4px;
  &::placeholder {
    color: #9399b2;
    font-weight: 400;
  }
`;

export const StyledErrorWrap = styled.p`
  font-size: 12px;
  font-weight: 400;
  padding: 0 16px;
  color: red;
`;
